module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAABqCAYAAACWEYATAAAAHElEQVQ4T2NkYGD4z8DAwMA4yhgNhNGUMHRyAQDH7WoBIsH07wAAAABJRU5ErkJggg=="